module.exports = __webpack_public_path__ + "img/footerbanner.475de6ae.png";